import React from "react";
import { reikiBenefits } from "../../../data/reiki/reiki-benefits";
import Chip from "../../shared/Chip";
import { 
    FaBolt, 
    FaShieldAlt, 
    FaHeart, 
    FaBalanceScale, 
    FaHeartbeat, 
    FaLeaf, 
    FaBed, 
    FaHandHoldingMedical, 
    FaSpa, 
    FaStethoscope, 
    FaMagic 
} from "react-icons/fa";

const ReikiBenefits = () => {
    const benefitsWithIcons = [
        { text: reikiBenefits.content[0], icon: FaBolt }, // Increased vitality
        { text: reikiBenefits.content[1], icon: FaShieldAlt }, // Stimulates the immune system
        { text: reikiBenefits.content[2], icon: FaHeart }, // Emotional healing
        { text: reikiBenefits.content[3], icon: FaBalanceScale }, // Hormone balancing
        { text: reikiBenefits.content[4], icon: FaHeartbeat }, // Aids in recovery after illness
        { text: reikiBenefits.content[5], icon: FaLeaf }, // Stress relief
        { text: reikiBenefits.content[6], icon: FaBed }, // Enhances sleep quality
        { text: reikiBenefits.content[7], icon: FaHandHoldingMedical }, // Pain relief
        { text: reikiBenefits.content[8], icon: FaSpa }, // Assists body in cleansing toxins
        { text: reikiBenefits.content[9], icon: FaStethoscope }, // Compliments medical treatment
        { text: reikiBenefits.content[10], icon: FaMagic }, // Boosts body's self-healing abilities
    ];

    return (
        <div className="px-1 px-md-5">
            <h2 className="text-md-center fw-bold display-5 mb-3 mb-md-5 pb-5 ms-3 ms-md-0">{reikiBenefits.heading}</h2>
            <div className="d-flex justify-content-center flex-wrap px-1 px-md-5" style={{ 
                gap: '10px'
            }}>
                {benefitsWithIcons.map((benefit, index) => (
                    <Chip 
                        key={index}
                        text={benefit.text} 
                        icon={benefit.icon} 
                    />
                ))}
            </div>
        </div>
    );
};

export default ReikiBenefits;